const o = [
  {
    name: '运营看板',
    src: require('@/assets/icon_navleft_01.png'),
    value: '/admin/index',
  },
  {
    name: '车辆定位',
    src: require('@/assets/icon_navleft_13.png'),
    value: '/admin/carposition',
  },
  {
    name: '财务分析',
    src: require('@/assets/icon_navleft_11.png'),
    value: '/admin/financialAnalysis',
  },
  {
    name: '运营分析',
    src: require('@/assets/icon_navleft_12.png'),
    value: '/admin/dataCenter',
  },
  {
    name: '订单管理',
    src: require('@/assets/icon_navleft_02.png'),
    value: '/order',
    children: [
      {
        name: '普通订单',
        value: '/order/nocontract',
      },
      {
        name: '合同订单',
        //src: require('@/assets/icon_navleft_01.png'),
        value: '/order/contract',
      },
      {
        name: '订单补差',
        value: '/order/makeup',
      },
      {
        name: '订单回收站',
        value: '/order/recycle',
      },
    ],
  },
  {
    name: '合同管理',
    src: require('@/assets/icon_navleft_03.png'),
    value: '/contract',
    children: [
      {
        name: '合同管理',
        value: '/contract/list',
      },
      {
        name: '合同补差',
        value: '/contract/makeup',
      },
    ],
  },
  {
    name: '客户管理',
    src: require('@/assets/icon_navleft_04.png'),
    value: '/customer',
    children: [
      {
        name: '客户列表',
        value: '/customer/manage',
      },
      {
        name: '承运人管理',
        value: '/customer/carrier',
      },
      {
        name: '操作日志',
        value: '/customer/log',
      },
    ],
  },
  {
    name: '车辆管理',
    src: require('@/assets/icon_navleft_05.png'),
    value: '/vehicle',
    children: [
      {
        name: '车辆列表',
        value: '/vehicle/manage',
      },
      // {
      //   name: '司机解绑记录',
      //   value: '/vehicle/unbindDriver',
      // },
      // {
      //   name: '押运解绑记录',
      //   value: '/vehicle/unbindEscort',
      // },

      // {
      //   name: '分组列表',
      //   value: '/vehicle/groupList',
      // },
      {
        name: '雇佣车辆',
        value: '/vehicle/expatriate',
      },
      {
        name: '挂车管理',
        value: '/vehicle/hang',
      },
      {
        name: '车队分组',
        value: '/vehicle/group',
      },
      {
        name: '违章管理',
        value: '/vehicle/breakRules',
      },
      {
        name: '车辆维护',
        value: '/vehicle/maintain',
      },
      {
        name: '隐患排查',
        value: '/vehicle/investDanger',
      },
      {
        name: '临期查询',
        value: '/vehicle/documents',
      },
    ],
  },
  {
    name: '维保管理',
    src: require('@/assets/icon_navleft_06.png'),
    value: '/fix',
    children: [
      {
        name: '维保列表',
        value: '/fix/list',
      },
      {
        name: '维修商管理',
        value: '/fix/repairer',
      },
      {
        name: '订单回收站',
        value: '/fix/recycle',
      },
    ],
  },
  {
    name: '人员管理',
    src: require('@/assets/icon_navleft_07.png'),
    value: '/staff',
    children: [
      {
        name: '车队经理管理',
        value: '/staff/manager/table',
      },
      {
        name: '主管会计管理',
        value: '/staff/mainAccountant/table',
      },
      {
        name: '分管会计管理',
        value: '/staff/specialAccountant/table',
      },
      {
        name: '出纳管理',
        value: '/staff/cashier/table',
      },
      {
        name: '车队长管理',
        value: '/staff/captain/table',
      },
      // {
      //   name: '副队长管理',
      //   value: '/staff/viceCaptain/table',
      // },
      {
        name: '机务管理',
        value: '/staff/maintenance/table',
      },
      {
        name: '车务管理',
        value: '/staff/vehicleService/table',
      },
      {
        name: '司机管理',
        value: '/staff/driver',
      },
      {
        name: '押运员管理',
        value: '/staff/escort',
      },
      {
        name: '打短司机管理',
        value: '/staff/tempDriver',
      },
      {
        name: '打短押运管理',
        value: '/staff/tempEscort',
      },
      {
        name: '业务员管理',
        value: '/staff/salesman/table',
      },
      {
        name: '签约管理',
        value: '/staff/staffcont',
      },
    ],
  },
  {
    name: '考勤管理',
    src: require('@/assets/icon_navleft_14.png'),
    value: '/attendance',
    children: [
      {
        name: '车辆考勤',
        value: '/attendance/vehicleAttendance',
      },
      {
        name: '考勤汇总',
        value: '/attendance/attendanceSummary',
      },
      {
        name: '司机出勤',
        value: '/attendance/driverAttendance',
      },
      {
        name: '押运出勤',
        value: '/attendance/escortAttendance',
      },
    ],
  },
  {
    name: '财务管理',
    src: require('@/assets/icon_navleft_08.png'),
    value: '/finance',
    children: [
      {
        name: '报销管理',
        value: '/finance/reimburse',
      },
      {
        name: '车辆异常管理',
        value: '/finance/financeFleetAbnormal',
      },
      {
        name: '运费统计表',
        value: '/finance/feightStatistics',
      },
      {
        name: '预支款管理',
        value: '/finance/initialPayment',
      },
      {
        name: '应收账款管理',
        value: '/finance/shipper',
      },
      {
        name: '应付账款管理',
        value: '/finance/carrier',
      },
      {
        name: '合同账款管理',
        value: '/finance/receivableAccounts',
      },
      // {
      //   name: '稳定基金管理',
      //   value: '/finance/stabilizationFund',
      // },
      {
        name: '固定费用支出表',
        value: '/finance/fixedFeeList',
      },
      {
        name: '出车费用汇总表',
        value: '/finance/expenseSummary',
      },
      {
        name: '油气费汇总表',
        value: '/finance/oilFee',
      },
      {
        name: '公司利润表',
        value: '/finance/companyProfit',
      },
      {
        name: '车队利润表',
        value: '/finance/estimatedProfit',
      },
      {
        name: '车队运营统计表',
        value: '/finance/financeFleetSummary',
      },
      // {
      //   name: '押运员预计工资',
      //   value: '/finance/escortSalary',
      // },
      {
        name: '车队长工资表',
        value: '/finance/captainSalary',
      },
      {
        name: '月度统计表',
        value: '/finance/monthlyStatistical',
      },
      {
        name: '月度分析表',
        value: '/finance/monthlyAnalysis',
      },
    ],
  },
  {
    name: '系统设置',
    src: require('@/assets/icon_navleft_09.png'),
    value: '/system',
    children: [
      {
        name: '预警阈值设置',
        value: '/system/warningConfig',
      },
      {
        name: '工资提成设置',
        value: '/finance/baseSalary',
      },
      {
        name: '固定费用配置',
        value: '/finance/fixedFee',
      },
      {
        name: '出车费用配置',
        value: '/finance/drivingFee',
      },
      {
        name: '油气站配置',
        value: '/system/stationConfig',
      },
      {
        name: '货物配置',
        value: '/system/cargoConfig',
      },
      {
        name: '维保类型配置',
        value: '/fix/config',
      },
      {
        name: '证件类型配置',
        value: '/system/documentConfig',
      },
      {
        name: '保险类型配置',
        value: '/system/insuranceConfig',
      },
      {
        name: '预支款配置',
        value: '/system/yzkConfig',
      },
      {
        name: '维护机构配置',
        value: '/system/maintainOrgConfig',
      },
      {
        name: '其他设置',
        value: '/system/others',
      },
      {
        name: '登录日志',
        value: '/system/loginLog',
      },
      {
        name: '操作日志',
        value: '/system/operationLog',
      },
    ],
  },
  // {
  //   name: '加油站管理',
  //   src: require('@/assets/icon_navleft_10.png'),
  //   value: '/oilStation',
  //   children: [
  //     {
  //       name: '燃油销售',
  //       value: '/oilStation/fuelSales',
  //     },
  //     {
  //       name: '库存',
  //       value: '/oilStation/stock',
  //     },
  //   ],
  // },
  // {
  //   name: '事项审核',
  //   src: require('@/assets/icon_navleft_11.png'),
  //   value: '/matterReview/list',
  // },
  {
    name: '帮助中心',
    src: require('@/assets/icon_navleft_15.png'),
    value: '/help',
    children: [
      {
        name: '更新日志',
        value: '/help/log',
      },
      // {
      //   name: '改进计划',
      //   value: '/help/improve',
      // },
    ],
  },
]

export default o